import React, { FC } from 'react'
import xcirclelogoblack from '../../assets/svg/xcirclelogoblack.svg'
import xcirclelogowhite from '../../assets/svg/xcirclelogowhite.svg'

export enum SUPPORTED_SOCIAL {
    LINKEDIN = "LinkedIn",
    X = "X"
}

interface Social {
    type: SUPPORTED_SOCIAL,
    shareLink: string,
    title?: string
}
export const Social: FC<Social> = (social) => {
    switch (social.type) {
        case SUPPORTED_SOCIAL.X:
            return (
                <a href={"https://x.com/intent/tweet?url=" + social.shareLink + (social.title ? "text=" + social.title : "")}
                    target="_blank" rel="nofollow noopener" title="Share on X" className="twitter">
                    <div id="default-svg">
                        <img id='xwhite' src={xcirclelogowhite} />
                        <img id='xblack' src={xcirclelogoblack} />
                    </div>
                </a>
            )
        case SUPPORTED_SOCIAL.LINKEDIN:
            return (
                <a href={"https://www.linkedin.com/shareArticle?url=" + social.shareLink + (social.title ? "&amptitle=" + social.title : "")}
                    target="_blank" rel="nofollow noopener" title="Share on LinkedIn" className="linkedin">
                    <i className="bx bxl-linkedin"></i>
                </a>
            )

        default: return <React.Fragment />
    }
}